import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import _ from 'lodash'

export const useErrorsStore = defineStore('errors', () => {
  const error = ref({
    code: null,
    description: null,
    message: null,
  })

  const requestErrorPopupIsShown = ref(false)

  const getError = computed(() => ({
    code: error.value.code,
    description: error.value.description,
    message: error.value.message ?? 'Something went wrong',
  }))

  function showRequestErrorPopup() {
    requestErrorPopupIsShown.value = true
  }

  function hideRequestErrorPopup() {
    requestErrorPopupIsShown.value = false
  }

  function setError(err) {
    if (!err) {
      console.error('setError called without error object')
      return
    }
    error.value = {
      code: err.error_code,
      description: err.error_description,
      message: err.error_message,
    }
  }

  function handleErrorStatus({ requestSlug, response }) {

    if (_.get(response, ['data', requestSlug, 'status']) === 'error') {
      const err = _.get(response, ['data', requestSlug, 'errors', '0']) || _.get(response, ['data', requestSlug, 'body', 'errors', '0'])
      setError(err)
      return
    }

    if (_.get(response, ['data', requestSlug, 'status']) === 'Error') {
      const err = _.get(response, ['data', requestSlug, 'errors', '0'])
      setError(err)
      return
    }

    if (
      _.get(response, ['data', requestSlug, 'success']) === false &&
      _.get(response, ['data', requestSlug, 'response', 'status']) === 'Error'
    ) {
      const err = _.get(response, ['data', requestSlug, 'response', 'errors', '0'])
      setError(err)
      return
    }

    if (response?.message === 'Internal server error') {
      setError({
        error_code: 201222.1,
        error_description: 'Internal server error',
        error_message: 'Internal server error',
      })
      return
    }

    if (requestSlug === 'getScene' && _.get(response, 'data.getImsScene') === null) {
      setError({
        error_code: 201222.2,
        error_description: 'Empty response from getScene',
        error_message: 'Empty response from getScene',
      })
      return
    }
  }

  return {
    error,
    requestErrorPopupIsShown,
    getError,
    showRequestErrorPopup,
    hideRequestErrorPopup,
    setError,
    handleErrorStatus,
  }
})
